import { IGlobalState } from '../reducers';
import { IState } from '../reducers/metadata';

export const getMetadata = (pathname: string) => (state: IGlobalState): IState['data'] => state.metadata.data[pathname];
